enum ROLES {
  viewer = 'viewer',
  fixedRatesEditor = 'fixed-rates-editor',
  reporter = 'reporter',
}

export default ROLES;
